import { Featured, HistoryRecord } from '@skinsoft/ui';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { UserDataStore, userSelectors } from '@skinsoft/auth';


export function resolveAuthor(
    source$: Observable<Featured | HistoryRecord>,
): Observable<Featured | HistoryRecord> {
    const userDataStore = UserDataStore.getInstance();
    return source$.pipe(
        switchMap(featured => {
            if (!featured.author) {
                return source$;
            }

            return userDataStore.fetchOne(featured.author as string).pipe(
                take(1),
                map(user => ({
                    ...featured,
                    author: userSelectors.fullName(user),
                })),
            );
        }),
    );
}
